<ng-container *ngIf="init$ | async as init">
  <app-loading *ngIf="init.isLoading"></app-loading>
  <app-error *ngIf="init.error as error" [error]="error"></app-error>

  <ng-container *ngIf="init.didSucceed">
    <div class="stepper-wrapper">
      <mat-stepper
        orientation="horizontal"
        [selectedIndex]="0"
        [linear]="true"
        #stepper
      >
        <mat-step>
          <ng-template matStepLabel>Edit primary pattern</ng-template>
          <ng-template matStepContent>
            <div class="step-content" *ngIf="stepper.selectedIndex === 0">
              <div class="error-section">
                <ng-container *ngIf="suggestionCard$ | async as suggestionCard">
                  <ng-container
                    *ngTemplateOutlet="
                      errorWrapper;
                      context: { suggestionCard: suggestionCard }
                    "
                  ></ng-container>
                </ng-container>
              </div>
              <app-pallet
                *ngIf="pattern?.altInitFormat as editPatternPrimary"
                [inputProject]="editPatternPrimary"
                #palletComponentPrimary
              ></app-pallet>
            </div>
          </ng-template>
        </mat-step>

        <mat-step *ngIf="secondPattern">
          <ng-template matStepLabel>Edit secondary pattern</ng-template>
          <ng-template matStepContent>
            <div class="step-content" *ngIf="stepper.selectedIndex === 1">
              <div class="error-section">
                <ng-container *ngIf="suggestionCard$ | async as suggestionCard">
                  <ng-container
                    *ngTemplateOutlet="
                      errorWrapper;
                      context: { suggestionCard: suggestionCard }
                    "
                  ></ng-container>
                </ng-container>
              </div>
              <app-pallet
                *ngIf="secondPattern.altInitFormat as editPatternSecondary"
                [inputProject]="editPatternSecondary"
                #palletComponentSecondary
              ></app-pallet>
            </div>
          </ng-template>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Edit hardware</ng-template>
          <ng-template matStepContent>
            <div class="step-content">
              <div class="error-section">
                <ng-container *ngIf="suggestionCard$ | async as suggestionCard">
                  <ng-container
                    *ngTemplateOutlet="
                      errorWrapper;
                      context: { suggestionCard: suggestionCard }
                    "
                  ></ng-container>
                </ng-container>
              </div>
              <app-page [dynamicHeight]="true">
                <app-hardware-configuration-card
                  #hardwareConfigurationComponent
                  [inputScene]="hardware.edited"
                  [returnChanges]="true"
                  [enableCancel]="false"
                  [disableActions]="true"
                  [enableDefaultValueRestore]="true"
                ></app-hardware-configuration-card>
              </app-page>
            </div>
          </ng-template>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Edit software</ng-template>
          <ng-template matStepContent>
            <div class="step-content">
              <div class="error-section">
                <ng-container *ngIf="suggestionCard$ | async as suggestionCard">
                  <ng-container
                    *ngTemplateOutlet="
                      errorWrapper;
                      context: { suggestionCard: suggestionCard }
                    "
                  ></ng-container>
                </ng-container>
              </div>
              <app-software-details
                [presetStrategy]="software.altInitFormat"
                [hideCardActions]="true"
                #simulationConfigurationComponent
              ></app-software-details>
            </div>
          </ng-template>
        </mat-step>
      </mat-stepper>
    </div>

    <app-wizard-bottom-navbar
      [title]="
        stepper.selectedIndex === 0
          ? 'Edit pattern'
          : stepper.selectedIndex === 1
          ? 'Edit hardware'
          : stepper.selectedIndex === 2
          ? 'Edit software'
          : 'Summary'
      "
      [secondaryButton]="'back'"
      [primaryButton]="stepper.selectedIndex < 2 ? 'next' : 'confirm'"
      (nextClick)="nextClick(stepper)"
      (backClick)="backClick(stepper)"
    ></app-wizard-bottom-navbar>
  </ng-container>
</ng-container>

<ng-template #errorWrapper let-suggestionCard="suggestionCard">
  <div class="error-wrapper">
    <app-highlighted-message-card
      *ngIf="suggestionCard?.info"
      [type]="'info'"
      [title]="'Retry Simulation'"
      [message]="suggestionCard.info"
    ></app-highlighted-message-card>
    <app-highlighted-message-card
      *ngIf="suggestionCard?.error"
      [type]="'error'"
      [title]="'Error'"
      [message]="suggestionCard.error"
    ></app-highlighted-message-card>

    <ng-container
      *ngIf="suggestionCard.suggestions?.length; else NoSuggestions"
    >
      <h3>Proposed Solutions:</h3>
      <mat-card
        class="suggestion-card"
        *ngFor="let suggestion of suggestionCard.suggestions"
      >
        {{ suggestion }}
      </mat-card>
    </ng-container>

    <ng-template #NoSuggestions>
      <h3>Suggestions:</h3>
      <mat-card class="suggestion-card">
        No specific solutions were given for this issue; try to modify some of
        the used settings.
      </mat-card>
      <mat-card class="suggestion-card">
        Check that all hardware configuration dimensions are correct.
      </mat-card>
      <mat-card class="suggestion-card">
        Adding an offset bracket can improve reach.
      </mat-card>
    </ng-template>
  </div>
</ng-template>
